import { render, staticRenderFns } from "./NeiBuGongShi6.vue?vue&type=template&id=d51e252a&scoped=true&"
import script from "./NeiBuGongShi6.vue?vue&type=script&lang=js&"
export * from "./NeiBuGongShi6.vue?vue&type=script&lang=js&"
import style0 from "./NeiBuGongShi6.vue?vue&type=style&index=0&id=d51e252a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d51e252a",
  null
  
)

export default component.exports